export default "__VITE_ASSET__BrUyvOAi__"